import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  pageable.sortField.value = 'code';

  const filters = ref({
    code: {value: null},
    address: {value: null},
    timeZone: {value: null},
    active: {value: null}
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.code?.value != null) {
      params['code'] = filters.value.code.value;
    }

    if (filters.value.address?.value != null) {
      params['address'] = filters.value.address.value;
    }

    if (filters.value.timeZone?.value != null) {
      params['timeZone'] = filters.value.timeZone.value;
    }

    if (filters.value.active?.value != null) {
      params['active'] = filters.value.active.value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


